import cx from 'clsx'
import React, { DetailedHTMLProps, FC, HTMLAttributes } from 'react'

import cn from '../styles.module.scss'

export interface ILabelProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  color?: 'black' | 'white' | 'gradient'
  weight?: 'normal' | 'medium' | 'bold'
  opacity?: number
  size?: 'h1' | 'h2' | 'h3' | 'big' | 'small'
}

const Label: FC<ILabelProps> = ({
  color = 'black',
  weight = 'normal',
  size = 'big',
  opacity = 1,
  style,
  className,
  children,
  ...rest
}) => {
  const classes = cx(cn[size], cn[color], cn[weight], className)
  return (
    <span {...rest} className={classes} style={{ opacity, ...style }}>
      {children}
    </span>
  )
}

export default Label
